import { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { api, errMsg, usePayConfig } from "@/lib/api";
import { PageTitle, Btn } from "@/admin/ui";

const csv = (rows) => ["email,name,joined,notified", ...rows.map((w) => [w.email, w.name || "", w.created_at, w.notified_at || ""].map((v) => `"${String(v).replace(/"/g, '""')}"`).join(","))].join("\n");

export default function Waitlist() {
  const [rows, setRows] = useState(null);
  const { data: cfg } = usePayConfig();
  const [err, setErr] = useState("");
  useEffect(() => { api.get("/admin/waitlist").then((r) => setRows(r.data)).catch((e) => { setErr(errMsg(e)); setRows([]); }); }, []);
  if (rows === null) return <p className="text-sm text-muted-foreground" data-testid="waitlist-loading">Loading waitlist…</p>;
  const exportCsv = () => {
    const a = document.createElement("a");
    a.href = URL.createObjectURL(new Blob([csv(rows)], { type: "text/csv" }));
    a.download = "namonics-india-waitlist.csv";
    a.click();
  };
  const pending = rows.filter((w) => !w.notified_at).length;
  return (
    <div>
      <PageTitle title="India Waitlist" sub="Visitors from India who asked to be told when online payment opens. Everyone is emailed automatically, once, as soon as live Razorpay keys are active.">
        <Btn onClick={exportCsv} data-testid="waitlist-export-btn"><Download className="mr-2 inline h-4 w-4" />Export CSV</Btn>
      </PageTitle>
      <p className="mb-4 text-sm text-muted-foreground" data-testid="waitlist-summary">
        {rows.length} signed up · {pending} waiting · Razorpay {cfg?.test_mode === false && cfg?.razorpay_key_id?.startsWith("rzp_live_") ? "live — announcements are being sent" : "not live yet — announcements will go out automatically when it is"}
      </p>
      {err && <p className="mb-4 text-sm text-red-400" data-testid="waitlist-error">Could not load the waitlist: {err}</p>}
      <div className="space-y-2 md:hidden">
        {rows.map((w) => (
          <div key={w.email} className="rounded-md border border-border p-3 text-sm" data-testid={`waitlist-card-${w.email}`}>
            <p className="truncate font-medium">{w.email}</p>
            <p className="text-xs text-muted-foreground">{w.name || "—"} · joined {w.created_at.slice(0, 10)} · {w.notified_at ? `notified ${String(w.notified_at).slice(0, 10)}` : w.attempts >= 5 ? "could not be emailed" : "waiting"}</p>
          </div>
        ))}
      </div>
      <div className="hidden overflow-x-auto rounded-md border border-border md:block">
        <table className="w-full text-sm" data-testid="waitlist-table">
          <thead className="bg-secondary/50 text-left text-xs uppercase text-muted-foreground"><tr>{["Email", "Name", "Joined (UTC)", "Notified (UTC)"].map((h) => <th key={h} className="px-3 py-2">{h}</th>)}</tr></thead>
          <tbody>
            {rows.map((w) => (
              <tr key={w.email} className="border-t border-border" data-testid={`waitlist-row-${w.email}`}>
                <td className="px-3 py-2">{w.email}</td><td className="px-3 py-2">{w.name || "—"}</td>
                <td className="px-3 py-2 text-xs">{w.created_at.slice(0, 16).replace("T", " ")}</td>
                <td className="px-3 py-2 text-xs">{w.notified_at ? String(w.notified_at).slice(0, 16).replace("T", " ") : w.attempts >= 5 ? "Could not be emailed" : "Waiting"}</td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={4} className="px-3 py-10 text-center text-muted-foreground">No signups yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
